<script>
export default {
  name: 'CountdownBanner',
  props: {
    brand: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      viewportWidth: window.innerWidth,
      countdownToDate: new Date('2021-03-13 14:00:00 GMT+1100'),
      countdownToDays: '00',
      countdownToHours: '00',
      countdownToMinutes: '00',
      countdownToSeconds: '00',
      visibleTime: new Date('2021-03-13 20:00:00 GMT+1100'),
    };
  },
  computed: {
    isMobileBanner() {
      return this.viewportWidth < 1080;
    },
    url() {
      const { brand } = this;
      return brand === 'punters'
        ? 'https://www.racingqueensland.com.au/racing-and-results/featured-events/qtis-jewel-2021?utm_source=news&utm_medium=digooh&utm_campaign=jewelraceday21'
        : ' https://www.racingqueensland.com.au/racing-and-results/featured-events/qtis-jewel-2021?utm_source=racenet&utm_medium=banner&utm_campaign=qtisjewelracenet';
    },
    isVisible() {
      return new Date() <= this.visibleTime;
    },
  },
  mounted() {
    window.addEventListener('resize', this.setWindowWidth);
    this.setWindowWidth();

    // start countdown
    setInterval(() => {
      const now = new Date();
      if (this.countdownToDate > now) {
        const { pad } = this;
        let diff = Math.abs(this.countdownToDate - now) / 1000;

        const days = Math.floor(diff / 86400);
        diff -= days * 86400;

        const hours = Math.floor(diff / 3600) % 24;
        diff -= hours * 3600;

        const minutes = Math.floor(diff / 60) % 60;
        diff -= minutes * 60;

        const seconds = Math.floor(diff % 60);

        this.countdownToDays = pad(days);
        this.countdownToHours = pad(hours);
        this.countdownToMinutes = pad(minutes);
        this.countdownToSeconds = pad(seconds);
      }
    }, 1000);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setWindowWidth);
  },
  methods: {
    setWindowWidth() {
      this.viewportWidth = window.innerWidth;
    },
    pad(number) {
      return number < 10 ? `0${number}` : number;
    },
  },
};
</script>

<template>
  <a v-if="isVisible" 
     :href="url" 
     target="_blank" 
     class="countdown-banner__container"
  >
    <div class="countdown-banner__countdown-container">

      <div class="countdown-banner__countdown">
        <b> {{ countdownToDays }} : {{ countdownToHours }} : {{ countdownToMinutes }} : {{ countdownToSeconds }} </b>
      </div>
      <div class="countdown-banner__countdown-time">
        DAYS HRS MINS SECS
      </div>
    </div>
   
  </a>
</template>
